import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const FileChip = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  background: ${colors.gray200};
  border: 1px solid ${colors.gray280};
  border-radius: 12px;
  padding: 4px 10px;
  font-size: 13px;
  color: ${colors.black};
  max-width: 200px;
`

export const FileChipName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const FileChipRemove = styled.button`
  background: none;
  border: none;
  color: ${colors.gray380};
  cursor: pointer;
  padding: 0;
  line-height: 1;
  font-size: 14px;
  flex-shrink: 0;

  &:hover {
    color: ${colors.black};
  }
`

export const SentImage = styled.img`
  display: block;
  max-width: 240px;
  max-height: 200px;
  border-radius: 10px;
  object-fit: cover;
  box-shadow: rgba(0, 0, 0, 0.15) 0 2px 8px;
`
